import LOCAL_STORAGE_KEYS from 'src/constants/localStorage';
import {
  SAR_BET_TYPES, SAR_BONUS_TYPES, SAR_IS_TEST, SAR_REPORT_EVENT_TYPES, SportActivityFilterModel, SportActivityReport,
} from 'src/pages/reports/sport/types/sportReportTypes';
import { LabelValueType } from '@sportsbook/shared';
import { CMSINFO_REDIRECT_QUERY } from 'src/constants/cmsInfoRedirectQuery';
import { EventSumsFilter } from 'src/pages/reports/sums/types/sumsReportTypes';
import { MARKET_SETTING_ENTITY_TYPE } from 'src/pages/FMS/types/FMSTypes';
import { EVENT_LIST_PAGE_SEARCH_PARAMS } from 'src/pages/eventsList/types';
import { GlobalSearchItem } from 'src/components/CommandMenu/globalSearch/types/globalSearchTypes';
import { GLOBAL_SEARCH_TYPES } from 'src/components/CommandMenu/globalSearch/utils/globalSearchUtils';
import toast from 'react-hot-toast';
import {
  BET_LIST_BET_TYPES_ALL,
  BET_LIST_BET_TYPES_FOLDS_AND_OTHER,
  BET_LIST_BET_TYPES_MULTIBETS,
  BET_LIST_BET_TYPES_SINGLES,
  BET_LIST_BET_TYPES_SYSTEM,
  BET_LIST_FREE_BET_TYPES_FREEBETS,
  BET_LIST_FREE_BET_TYPES_NO_RISK_FREEBETS,
  BET_LIST_IS_TEST_TEST_BETS,
  BET_LIST_IS_TEST_REAL_BETS,
  BET_LIST_PAGE_SEARCH_PARAMS,
  BET_SHOP_BONUS_WITH_1_GAME_CUT,
  BET_SHOP_BONUS_WITH_ACCUMULATOR_BONUS,
  BET_SHOP_BONUS_WITH_BONUS,
  BET_SHOP_BONUS_WITH_SUPERCHARGED_ODDS,
  BET_SHOP_BONUS_WITHOUT_BONUS,
  BetListFilterModel,
  BET_LIST_ALL_EVENT_TYPE,
  BET_LIST_LIVE_EVENT_TYPE,
  BET_LIST_PREMATCH_EVENT_TYPE,
  BETS_WITH_ODDBOOST,
} from '../pages/bets/types/betListTypes';
import { BoostedOddModel } from '../pages/boostedOdds/types/boostedOddsAPITypes';
import { PlayerCardTabs } from '../pages/playerCardComponents/playerCardTypes';
import { isInIframe } from './routeUtils';

export const redirectToPlayerCard = (
  FranchiseId: number,
  PlayerUuid: string,
  tab: PlayerCardTabs,
): void => {
  if (isInIframe) {
    window.top?.postMessage({ func: 'setQueryParams', message: `${CMSINFO_REDIRECT_QUERY.PLAYER_CARD}:${FranchiseId}:${PlayerUuid}`, target: '_blank' }, '*');
  } else {
    window.open(`/playerCard/${FranchiseId}/${PlayerUuid}?tab=${tab}`);
  }
};

export const redirectToPlayerBets = (playerId: number): void => {
  if (isInIframe) {
    window.top?.postMessage({ func: 'setQueryParams', message: `${CMSINFO_REDIRECT_QUERY.BETS_BY_PLAYER}:${playerId}:${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}`, target: '_blank' }, '*');
  } else {
    window.open(`/bets?${BET_LIST_PAGE_SEARCH_PARAMS.PLAYER_ID}=${playerId}&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true`);
  }
};

export const redirectToBoostedOddsBets = (row: BoostedOddModel): void => {
  if (!row?.Id) return;

  const shouldSetNoDateString = `&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true`;

  const betListFilter: BetListFilterModel = {
    OddBoostId: String(row.Id),
  };

  localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));

  if (isInIframe) {
    window.top?.postMessage(
      {
        func: 'setQueryParams',
        message: `${CMSINFO_REDIRECT_QUERY.BETS_BY_BOOSTED_ODD_ID}:${row.Id}:${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}`,
        target: '_blank',
      },
      '*',
    );
  } else {
    window.open(
      `/bets?${BET_LIST_PAGE_SEARCH_PARAMS.BOOSTED_ODD_ID}=${row.Id}${shouldSetNoDateString}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`,
    );
  }
};

const mapSarEventTypeToBetListEventType = (eventType: LabelValueType): LabelValueType => {
  switch (Number(eventType.value)) {
    case SAR_REPORT_EVENT_TYPES.BOTH:
      return BET_LIST_ALL_EVENT_TYPE;
    case SAR_REPORT_EVENT_TYPES.PREMATCH:
      return BET_LIST_PREMATCH_EVENT_TYPE;
    case SAR_REPORT_EVENT_TYPES.LIVE:
      return BET_LIST_LIVE_EVENT_TYPE;
    default:
      return BET_LIST_ALL_EVENT_TYPE;
  }
};

const mapSARFilterToBetListFilter = (currentFilters: SportActivityFilterModel): BetListFilterModel => {
  const betListFilter: BetListFilterModel = {
    datePlaced: currentFilters.DatePlaced ? currentFilters.DatePlaced : undefined,
    dateClosed: currentFilters.DateClosed,
    playerID: currentFilters.PlayerId,
    type: currentFilters.EventTypes && mapSarEventTypeToBetListEventType(currentFilters.EventTypes),
    sportsIds: currentFilters.SportIds,
    tournamentIds: currentFilters.TournamentIds,
    betBuilder: currentFilters.BetBuilderFilter,
    feeds: currentFilters.FeedProviderIds,
    isTest: currentFilters.IsTest?.value === SAR_IS_TEST.TRUE ? BET_LIST_IS_TEST_TEST_BETS : BET_LIST_IS_TEST_REAL_BETS,
    RiskSegmentUuids: currentFilters.RiskSegmentUuids,
    FranchiseIds: currentFilters.FranchiseIds,
  };

  if (currentFilters.BonusTypes && currentFilters.BonusTypes.length > 0) {
    currentFilters.BonusTypes.forEach((bonusType) => {
      switch (Number(bonusType.value)) {
        case SAR_BONUS_TYPES.BONUS:
          betListFilter.BetShopBonus = BET_SHOP_BONUS_WITH_BONUS;
          break;
        case SAR_BONUS_TYPES.FREE_BET:
          betListFilter.freebet = BET_LIST_FREE_BET_TYPES_FREEBETS;
          break;
        case SAR_BONUS_TYPES.NO_RISK_BET:
          betListFilter.freebet = BET_LIST_FREE_BET_TYPES_NO_RISK_FREEBETS;
          break;
        case SAR_BONUS_TYPES.ONE_CUT_BONUS:
          betListFilter.freebet = BET_SHOP_BONUS_WITH_1_GAME_CUT;
          break;
        case SAR_BONUS_TYPES.REAL_MONEY:
          betListFilter.BetShopBonus = BET_SHOP_BONUS_WITHOUT_BONUS;
          break;
        case SAR_BONUS_TYPES.SUPER_CHARGED_ODDS_BONUS:
          betListFilter.BetShopBonus = BET_SHOP_BONUS_WITH_SUPERCHARGED_ODDS;
          break;
        case SAR_BONUS_TYPES.YAKATA:
          betListFilter.BetShopBonus = BET_SHOP_BONUS_WITH_ACCUMULATOR_BONUS;
          break;
        case SAR_BONUS_TYPES.ODD_BOOSTED:
          betListFilter.BetShopBonus = BETS_WITH_ODDBOOST;
          break;
        default:
          break;
      }
    });
  }

  if (currentFilters.BetTypes && currentFilters.BetTypes.length > 0) {
    const betListTypes: LabelValueType[] = [];
    currentFilters.BetTypes.forEach((betType) => {
      switch (betType.value) {
        case SAR_BET_TYPES.ALL:
          betListTypes.push(BET_LIST_BET_TYPES_ALL);
          break;
        case SAR_BET_TYPES.SINGLES:
          betListTypes.push(BET_LIST_BET_TYPES_SINGLES);
          break;
        case SAR_BET_TYPES.MULTIBETS:
          betListTypes.push(BET_LIST_BET_TYPES_MULTIBETS);
          break;
        case SAR_BET_TYPES.SYSTEM:
          betListTypes.push(BET_LIST_BET_TYPES_SYSTEM);
          break;
        case SAR_BET_TYPES.FOLDS:
          betListTypes.push(BET_LIST_BET_TYPES_FOLDS_AND_OTHER);
          break;
        default:
          break;
      }
    });

    betListFilter.BetTypes = betListTypes;
  }

  return betListFilter;
};

export const handleSARPlayerIDClick = (
  report: SportActivityReport,
  tab: PlayerCardTabs,
):void => {
  if (report.PlayerUuid && report.FranchiseId) {
    if (isInIframe) {
      window.top?.postMessage({ func: 'setQueryParams', message: `${CMSINFO_REDIRECT_QUERY.PLAYER_CARD}:${report.FranchiseId}:${report.PlayerUuid}`, target: '_blank' }, '*');
    } else {
      window.open(`../playerCard/${report.FranchiseId}/${report.PlayerUuid}?tab=${tab}`);
    }
  }
};

export const handleSAREventIDClick = (report: SportActivityReport, filters: SportActivityFilterModel):void => {
  if (report.GroupId) {
    const betListFilter: BetListFilterModel = mapSARFilterToBetListFilter(filters);
    const shouldSetNoDate = !!filters.DateClosed || !!filters.DatePlaced;
    const shouldSetNoDateString = shouldSetNoDate ? `&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true` : '';

    localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));
    if (isInIframe) {
      window.top?.postMessage({
        func: 'setQueryParams',
        message: `${CMSINFO_REDIRECT_QUERY.BETS_BY_EVENT}:${report.GroupId}:${shouldSetNoDate ? BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE : ''}`,
        target: '_blank',
      }, '*');
    } else {
      window.open(`/bets?${BET_LIST_PAGE_SEARCH_PARAMS.EVENT_ID}=${report.GroupId}${shouldSetNoDateString}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`);
    }
  }
};

export const handleSARPlayerIDRedirectToEvent = (report: SportActivityReport, filters: SportActivityFilterModel):void => {
  if (report.PlayerId) {
    const betListFilter: BetListFilterModel = mapSARFilterToBetListFilter(filters);

    const shouldSetNoDate = !!filters.DateClosed || !!filters.DatePlaced;
    const shouldSetNoDateString = shouldSetNoDate ? `&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true` : '';

    localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));
    if (isInIframe) {
      window.top?.postMessage({
        func: 'setQueryParams',
        message: `${CMSINFO_REDIRECT_QUERY.BETS_BY_PLAYER}:${report.PlayerId}:${shouldSetNoDate ? BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE : ''}`,
        target: '_blank',
      }, '*');
    } else {
      window.open(`/bets?${BET_LIST_PAGE_SEARCH_PARAMS.PLAYER_ID}=${report.PlayerId}${shouldSetNoDateString}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`);
    }
  }
};

export const handleSARRedirectToSport = (report: SportActivityReport, filters: SportActivityFilterModel):void => {
  if (report.GroupId) {
    const newFilters: SportActivityFilterModel = {
      ...filters,
      SportIds: [
        {
          label: report.Name as string,
          value: report.GroupId,
        },
      ],
    };
    const betListFilter: BetListFilterModel = mapSARFilterToBetListFilter(newFilters);

    const shouldSetNoDate = !!filters.DateClosed || !!filters.DatePlaced;
    const shouldSetNoDateString = shouldSetNoDate ? `&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true` : '';

    localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));
    if (isInIframe) {
      window.top?.postMessage({ func: 'setQueryParams', message: `${CMSINFO_REDIRECT_QUERY.BETS_OVERVIEW}:${shouldSetNoDate ? BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE : ''}`, target: '_blank' }, '*');
    } else {
      window.open(`/bets?${shouldSetNoDateString}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`);
    }
  }
};

export const handleSARRedirectToTournament = (report: SportActivityReport, filters: SportActivityFilterModel):void => {
  if (report.GroupId && report.SportId && report.TournamentId) {
    const newFilters: SportActivityFilterModel = {
      ...filters,
      SportIds: [
        {
          label: report.SportName as string,
          value: report.SportId.toString(),
        },
      ],
      TournamentIds: [
        {
          label: report.TournamentName as string,
          value: report.TournamentId.toString(),
        },
      ],
    };
    const betListFilter: BetListFilterModel = mapSARFilterToBetListFilter(newFilters);

    const shouldSetNoDate = !!filters.DateClosed || !!filters.DatePlaced;
    const shouldSetNoDateString = shouldSetNoDate ? `&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true` : '';

    localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));
    if (isInIframe) {
      window.top?.postMessage({ func: 'setQueryParams', message: `${CMSINFO_REDIRECT_QUERY.BETS_OVERVIEW}:${shouldSetNoDate ? BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE : ''}`, target: '_blank' }, '*');
    } else {
      window.open(`/bets?${shouldSetNoDateString}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`);
    }
  }
};

export const handleSARRedirectToMarketType = (
  report: SportActivityReport,
  filters: SportActivityFilterModel,
): void => {
  if (report.UnionId && report.Name && report.SportId && report.SportName) {
    const newFilters: SportActivityFilterModel = {
      ...filters,
      SportIds: [
        {
          label: report.SportName as string,
          value: report.SportId.toString(),
        },
      ],
    };

    const betListFilter: BetListFilterModel = mapSARFilterToBetListFilter(newFilters);

    betListFilter.MarketUnionIds = [
      {
        label: report.Name.toString(),
        value: report.UnionId.toString(),
      },
    ];

    const shouldSetNoDate = !!filters.DateClosed || !!filters.DatePlaced;
    const shouldSetNoDateString = shouldSetNoDate
      ? `&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true`
      : '';

    localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));

    if (isInIframe) {
      window.top?.postMessage(
        {
          func: 'setQueryParams',
          message: `${CMSINFO_REDIRECT_QUERY.BETS_OVERVIEW}:${report.UnionId}:${shouldSetNoDate ? BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE : ''}`,
          target: '_blank',
        },
        '*',
      );
    } else {
      window.open(
        `/bets?${BET_LIST_PAGE_SEARCH_PARAMS.MARKET_UNION_ID}=${report.UnionId}${shouldSetNoDateString}&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`,
      );
    }
  }
};

export const handleSumsReportRedirectToBetListByEvent = (filters?: EventSumsFilter, OddId?: number, AdditionalValue?: number):void => {
  if (filters?.EventId) {
    const betListFilter: BetListFilterModel = {
      eventID: filters.EventId,
      FranchiseIds: filters.FranchiseIds,
      OddId,
      AdditionalValue,
    };

    switch (filters.IsLive?.value) {
      case MARKET_SETTING_ENTITY_TYPE.Inplay:
        betListFilter.type = BET_LIST_LIVE_EVENT_TYPE;
        break;
      case MARKET_SETTING_ENTITY_TYPE.Prematch:
        betListFilter.type = BET_LIST_PREMATCH_EVENT_TYPE;
        break;
      default:
        break;
    }

    localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));
    if (isInIframe) {
      window.top?.postMessage({
        func: 'setQueryParams',
        message: `${CMSINFO_REDIRECT_QUERY.BETS_BY_EVENT}:${filters.EventId}:${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}`,
        target: '_blank',
      }, '*');
    } else {
      window.open(`/bets?${BET_LIST_PAGE_SEARCH_PARAMS.EVENT_ID}=${filters.EventId}&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`);
    }
  }
};

export const handleImageClickRedirectToBetList = (eventId: number) => (e: React.MouseEvent<SVGSVGElement>): void => {
  e.stopPropagation();
  if (isInIframe) {
    window.top?.postMessage({
      func: 'setQueryParams',
      message: `${CMSINFO_REDIRECT_QUERY.BETS_BY_EVENT}:${eventId}:${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}`,
      target: '_blank',
    }, '*');
  } else {
    window.open(`/bets?${BET_LIST_PAGE_SEARCH_PARAMS.EVENT_ID}=${eventId}&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true`);
  }
};

export const handleRedirectToEventList = (eventId: number, eventStartDate: string, providerId: number): void => {
  if (isInIframe) {
    window.top?.postMessage({
      func: 'setQueryParams',
      message: `${CMSINFO_REDIRECT_QUERY.EVENT_LIST}:${eventId}:${eventStartDate}:${providerId}`,
      target: '_blank',
    }, '*');
  } else {
    window.open(`/eventsList?${EVENT_LIST_PAGE_SEARCH_PARAMS.EVENT_ID}=${eventId}`
      + `&${EVENT_LIST_PAGE_SEARCH_PARAMS.EVENT_START_DATE}=${eventStartDate}`
      + `&${EVENT_LIST_PAGE_SEARCH_PARAMS.PROVIDER_ID}=${providerId}`, '_blank');
  }
};

export const handleEventListRedirectToSumsReport = (eventId: number): void => {
  if (isInIframe) {
    window.top?.postMessage({ func: 'setQueryParams', message: `${CMSINFO_REDIRECT_QUERY.SUMS_REPORT}:${eventId}`, target: '_blank' }, '*');
  } else {
    window.open(`/reports/sums?eid=${eventId}`);
  }
};

export const handleGlobalSearchRedirect = (item: GlobalSearchItem): void => {
  switch (item.Type) {
    case GLOBAL_SEARCH_TYPES.PLAYER_LOGIN:
    case GLOBAL_SEARCH_TYPES.PLAYER_ID:
    case GLOBAL_SEARCH_TYPES.EXTERNAL_PLAYER_ID:
      redirectToPlayerCard(Number(item.AdditionalInfo.FranchiseId), item.DataUuid, PlayerCardTabs.Overview);
      break;
    default:
      toast.error('Unknown search result type. Cannot redirect.');
  }
};

export const handlePrebuildViewRedirectToBetList = (preBuildEventItemId: number, eventId: number):void => {
  if (preBuildEventItemId) {
    const betListFilter: BetListFilterModel = {
      eventID: eventId,
      PreBuildEventItemId: preBuildEventItemId,
    };

    localStorage.setItem(LOCAL_STORAGE_KEYS.BET_LIST_FILTER, JSON.stringify(betListFilter));
    if (isInIframe) {
      window.top?.postMessage({ func: 'setQueryParams', message: `${CMSINFO_REDIRECT_QUERY.BETS_BY_EVENT}:${eventId}:${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}`, target: '_blank' }, '*');
    } else {
      window.open(`/bets?${BET_LIST_PAGE_SEARCH_PARAMS.EVENT_ID}=${eventId}&${BET_LIST_PAGE_SEARCH_PARAMS.SET_NO_DATE}=true&${BET_LIST_PAGE_SEARCH_PARAMS.IS_REDIRECT}=true`);
    }
  }
};
